import { brandTitle, BrandTitle } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class BrandCreateVO {
  private static validation = JsonSchemaValidator.compile(
    BrandCreateVO.validationSchema()
  );

  constructor(readonly value: BrandCreate) {
    JsonSchemaValidator.assert(BrandCreateVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["title"],
      properties: {
        title: brandTitle
      },
      additionalProperties: false
    };
  }
}

interface BrandCreate {
  title: BrandTitle;
}
